module.exports = __webpack_public_path__ + "img/Etihad-Airways.88165ba6.png";